// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2287) return "static/chunks/2287-81c271e957e1f327.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"318":"495f75fc6421b3dd","551":"d1db8566593758f5","857":"e53282d2d787c935","5691":"6efcdc1035fffd0d","5953":"2c52bd845f7776d1","7981":"1d5ddb1fb4169b09","8576":"710e063eb4caeb7d"}[chunkId] + ".js";
};